import { ImageProps } from '@/components/atoms/image/image';

const variables: {
  imageAspectRatio: ImageProps['aspectRatio'];
} = {
  imageAspectRatio: 'oneByOne',
};

export default variables;
